module.exports = __webpack_public_path__ + "img/cbr2r10-1.2c6b5a49.gif";